<template>
    <div class="flex py-2 px-3 w-full">
         <p class="w-full">
           <label  class=" text-sm block w-full font-semibold">{{ title }}</label>
           <span class="opacity-75 text-sm block w-full  capitalize">{{ label }}</span>
           <span class="text-sm"><slot></slot></span>
         </p>
      </div>
</template>

<script>
    export default {
        props:["title", "img", "label", "noHeader"],
        mounted() {
           
        },
        computed: {
            imgSrc(){
                return "'"+this.img+"'"
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>